/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneAttributesNewRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneAttributesNewRoute, {
  overrideRenderTemplate: false,
});
